import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./dwsTable";
import WGRTotals from "./dwsTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
    return rows.reduce(
      (sum, row) => {

        const dl = Number(row["DIRECT LABOUR"] || 0);
        const ds = Number(row["DIRECT STORE"] || 0);
        const ocl = Number(row["ON COST LABOUR"] || 0);
        const ocs = Number(row["ON COST STORE"] || 0);
        const total = dl + ds + ocl + ocs;


        return {
          dl: sum.dl + dl,
          ds: sum.ds + ds,
          ocl: sum.ocl + ocl,
          ocs: sum.ocs + ocs,
          total: sum.total + total,

        };
      },
      {
        dl: 0,
        ds: 0,
        ocl: 0,
        ocs: 0,
        total: 0,






      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt: 5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}

        >
          {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

